import { useEffect } from "react";
import LegalLayout from "./LegalLayout";
import { setPageMeta } from "../lib/seo";

export default function PrivacyPolicy() {
    useEffect(() => {
        setPageMeta({
            title: "Privacy Policy — TecSuite",
            description:
                "Informativa sul trattamento dei dati personali di tecsuite.it ai sensi del GDPR: titolare, finalità, base giuridica, conservazione, diritti dell'interessato.",
            canonical: "https://tecsuite.it/privacy",
        });
        window.scrollTo(0, 0);
    }, []);

    return (
        <LegalLayout title="Privacy Policy" updatedAt="04/07/2026">
            <p>
                La presente informativa descrive le modalità di trattamento dei dati personali degli
                utenti che consultano il sito <strong>tecsuite.it</strong> e che utilizzano i servizi
                offerti tramite lo stesso. L&apos;informativa è resa ai sensi del Regolamento (UE)
                2016/679 (&quot;GDPR&quot;) e del D.lgs. 196/2003 e s.m.i. (&quot;Codice Privacy&quot;).
            </p>

            <h2>1. Titolare del trattamento</h2>
            <p>
                Il Titolare del trattamento è <strong>Tecnologie S.r.l.</strong>, con sede legale in
                Viale dell&apos;Industria, 11 — 37023 Grezzana (VR), Italia.
                <br />
                Contatti: telefono <a href="tel:+390454770241">045 4770241</a> — email{" "}
                <a href="mailto:info@tecsuite.it">info@tecsuite.it</a>.
            </p>

            <h2>2. Tipologie di dati raccolti</h2>
            <p>
                Il sito raccoglie le seguenti categorie di dati personali:
            </p>
            <ul>
                <li>
                    <strong>Dati di contatto forniti volontariamente</strong> tramite il modulo di
                    richiesta demo: nome e cognome, azienda, indirizzo email, numero di telefono
                    (facoltativo), ruolo (facoltativo), messaggio (facoltativo).
                </li>
                <li>
                    <strong>Dati di navigazione</strong>: informazioni raccolte automaticamente dai
                    sistemi informatici (indirizzo IP, tipo di browser, sistema operativo, pagine
                    visitate, data e ora della visita, referrer) per garantire il corretto
                    funzionamento del sito e per finalità di sicurezza.
                </li>
                <li>
                    <strong>Cookie tecnici</strong>: come descritto nell&apos;apposita{" "}
                    <a href="/cookie">Cookie Policy</a>.
                </li>
            </ul>

            <h2>3. Finalità e base giuridica del trattamento</h2>
            <p>I dati personali sono trattati per le seguenti finalità:</p>
            <ul>
                <li>
                    <strong>a) Riscontro alle richieste degli utenti</strong> (es. richiesta demo o
                    informazioni commerciali): la base giuridica è l&apos;esecuzione di misure
                    precontrattuali richieste dall&apos;interessato (art. 6.1.b GDPR).
                </li>
                <li>
                    <strong>b) Adempimenti di legge</strong>: la base giuridica è l&apos;obbligo
                    legale a cui è soggetto il Titolare (art. 6.1.c GDPR).
                </li>
                <li>
                    <strong>c) Sicurezza del sito e prevenzione abusi</strong>: la base giuridica è
                    il legittimo interesse del Titolare (art. 6.1.f GDPR).
                </li>
                <li>
                    <strong>d) Comunicazioni commerciali</strong> relative ai prodotti e servizi
                    TecSuite: solo previo consenso esplicito dell&apos;interessato (art. 6.1.a GDPR),
                    revocabile in ogni momento.
                </li>
            </ul>

            <h2>4. Modalità del trattamento</h2>
            <p>
                Il trattamento è effettuato con strumenti manuali, informatici e telematici, adottando
                misure tecniche e organizzative adeguate a garantire la sicurezza, la disponibilità,
                l&apos;integrità e la riservatezza dei dati (art. 32 GDPR), in modo da prevenirne la
                perdita, l&apos;uso improprio, l&apos;accesso non autorizzato e la divulgazione.
            </p>

            <h2>5. Conservazione dei dati</h2>
            <ul>
                <li>
                    <strong>Dati del modulo contatti</strong>: conservati per il tempo necessario a
                    dare seguito alla richiesta e, comunque, non oltre 24 mesi dall&apos;ultima
                    interazione, salvo diverso obbligo di legge.
                </li>
                <li>
                    <strong>Dati di navigazione</strong>: conservati per il periodo strettamente
                    necessario alle finalità di sicurezza e diagnostica, generalmente non oltre 12
                    mesi.
                </li>
                <li>
                    <strong>Dati per obblighi di legge</strong>: conservati per la durata prevista
                    dalla normativa applicabile.
                </li>
            </ul>

            <h2>6. Destinatari e comunicazione dei dati</h2>
            <p>
                I dati potranno essere trattati da personale autorizzato del Titolare e da soggetti
                esterni nominati Responsabili del trattamento ai sensi dell&apos;art. 28 GDPR, tra cui:
            </p>
            <ul>
                <li>fornitori di servizi di hosting, cloud e infrastruttura;</li>
                <li>fornitori di servizi email, CRM e comunicazione;</li>
                <li>consulenti legali, fiscali e amministrativi;</li>
                <li>autorità competenti nei casi previsti dalla legge.</li>
            </ul>
            <p>
                I dati non saranno oggetto di diffusione né ceduti a terzi per finalità di marketing
                senza il consenso dell&apos;interessato.
            </p>

            <h2>7. Trasferimento dei dati fuori UE</h2>
            <p>
                I dati sono conservati preferibilmente su server ubicati nello Spazio Economico
                Europeo. In caso di trasferimento verso Paesi terzi, il Titolare garantisce
                l&apos;adozione di misure di tutela adeguate (Standard Contractual Clauses o altre
                garanzie previste dagli artt. 45-49 GDPR).
            </p>

            <h2>8. Diritti dell&apos;interessato</h2>
            <p>
                In qualsiasi momento è possibile esercitare i seguenti diritti nei confronti del
                Titolare:
            </p>
            <ul>
                <li>accesso ai dati personali (art. 15 GDPR);</li>
                <li>rettifica dei dati inesatti o incompleti (art. 16 GDPR);</li>
                <li>
                    cancellazione dei dati, nei limiti di legge (art. 17 GDPR — diritto all&apos;oblio);
                </li>
                <li>limitazione del trattamento (art. 18 GDPR);</li>
                <li>portabilità dei dati (art. 20 GDPR);</li>
                <li>opposizione al trattamento (art. 21 GDPR);</li>
                <li>revoca del consenso, senza pregiudicare la liceità del trattamento anteriore;</li>
                <li>
                    proporre reclamo all&apos;Autorità Garante per la Protezione dei Dati Personali
                    (<a href="https://www.garanteprivacy.it" target="_blank" rel="noreferrer noopener">
                        www.garanteprivacy.it
                    </a>).
                </li>
            </ul>
            <p>
                Le richieste possono essere inviate a{" "}
                <a href="mailto:info@tecsuite.it">info@tecsuite.it</a>.
            </p>

            <h2>9. Obbligatorietà del conferimento</h2>
            <p>
                Il conferimento dei dati contrassegnati come obbligatori nel modulo di contatto è
                necessario per dare seguito alla richiesta; il mancato conferimento renderà
                impossibile riscontrare la stessa. Il conferimento degli altri dati è facoltativo.
            </p>

            <h2>10. Processi decisionali automatizzati</h2>
            <p>
                Il Titolare non adotta processi decisionali interamente automatizzati che producano
                effetti giuridici o comunque significativi sugli interessati.
            </p>

            <h2>11. Modifiche all&apos;informativa</h2>
            <p>
                Il Titolare si riserva il diritto di aggiornare la presente informativa in ogni
                momento, dandone comunicazione tramite pubblicazione sul sito. Si invita l&apos;utente
                a consultare periodicamente questa pagina.
            </p>

            <p className="text-xs text-slate-500 mt-10">
                Il presente testo è predisposto come modello standard e va integrato/verificato da un
                consulente qualificato in base alle specifiche modalità di trattamento adottate.
            </p>
        </LegalLayout>
    );
}
